//
import { ApolloClient } from 'apollo-client'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { HttpLink } from 'apollo-link-http'
import { onError } from 'apollo-link-error'
import gql from 'graphql-tag'
import auth from '@it-enterprise/jwtauthentication'
import Vue from 'vue'
// QUERIES
const queries = {}
const mutations = {}
const queryContext = require.context('./graphql/query/', true, /\.graphql$/)
const mutationContext = require.context('./graphql/mutation/', true, /\.graphql$/)
queryContext.keys().forEach(key => {
  queries[key.replace(/\.(\/|graphql)/g, '')] = queryContext(key)
})

mutationContext.keys().forEach(key => {
  mutations[key.replace(/\.(\/|graphql)/g, '')] = mutationContext(key)
})

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (networkError && networkError.statusCode === 401) {
    auth.clearTokens()
    Vue.$routerCore.GoToSignIn()
  }
  if (graphQLErrors) {
    // TODO: Обработать ошибку
    Vue.$authCore.store.commit('SET_ERROR', { text: 'Ошибка обращения к данным' })
    Vue.$authCore.store.commit('SET_PROCESSING', false)
    return graphQLErrors.message
  }
})

const getClient = async schema => {
  const token = await auth.getToken()
  const options = {
    // eslint-disable-next-line no-undef
    uri: appConfig.GrapgQlUrl + 'api/graphql',
    credentials: 'include',
    headers: {
      Authorization: `Bearer ${token}`,
      schema: schema ?? 'EnergyAccount'
    }
  }
  const httpLink = new HttpLink(options)
  return new ApolloClient({
    cache: new InMemoryCache({
      addTypename: false
    }),
    link: errorLink.concat(httpLink)
  })
}

export { getClient }

function getOperationsFromModel() {
  if (!Vue.$authCore.store.getters.DataSources) {
    return []
  }
  return Vue.$authCore.store.getters.DataSources.map(x => {
    return { $ID: x.$ID, Query: x.Query, Mutations: x.Mutations, GraphQlSchema: x.GraphQlSchema }
  })
}

async function callLocalOperation(client, options, args) {
  if (isQuery(options.operationId)) {
    return await client.query({
      query: gql`${queries[options.operationId]}`,
      variables: args
    })
  }
  return await client.mutate({
    mutation: gql`${mutations[options.operationId]}`,
    variables: args
  })
}

async function callModelOperation(options, args) {
  let ds = getOperationsFromModel().find(x => x.$ID == options.dataSourceId)
  const client = await getClient(ds.GraphQlSchema)
  if (!options.operationId) {
    return await client.query({
      query: gql`${ds.Query}`,
      variables: args
    })
  }

  let mutation = ds.Mutations.find(x => x.$ID == options.operationId).Value
  return await client.mutate({
    mutation: gql`${mutation}`,
    variables: args
  })
}

function isQuery(key) {
  return mutations[key] == undefined
}

export class GraphqQlApi {
  static async callOperation(options, args) {
    try {
      const client = await getClient()
      if (!options.dataSourceId) {
        return await callLocalOperation(client, options, args)
      }
      return await callModelOperation(options, args)
    } catch (e) {
      throw new Error(e.message)
    }
  }

  // get model 
  static async getModelFromGqlAsync(id) {
    try {
      const client = await getClient('WebAppModeler')
      return await client.query({
        query: gql`${queries.model}`,
        variables: { id }
      })
    } catch (e) {
      throw new Error(e.message)
    }
  }
}
